import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from "../services/global.service";
import { CarregandoService } from "../services/carregando.service";
import { ProdutoService } from "../services/produto.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { PedidoService } from "../services/pedido.service";
import { ClienteService } from "../services/cliente.service";
import { NotificacaoService } from "../services/notificacao.service";
import { PremissasService } from "../services/premissas.service";
import { LogAcessoService } from "../services/log-acesso.service";
import { UtilitarioService } from "../services/utilitario.service";
import { MarcaService } from "../services/marca.service";
import { SegmentacaoService } from "../services/segmentacao.service";
import { FornecedorService } from "../services/fornecedor.service";
import { ArquivoService } from "../services/arquivo.service";
import { MenuProdutoService } from "../services/menuprodutoservice";
import { ProdutoCampoPersonalizadoService } from "../services/produto-campo-personalizado.service";
import { MenuSelecionadoService } from "../services/menuselecionado.service";
import { PrecificacaoUFService } from "../services/precificacao-uf.service";
import { ItemPedido, Pedido } from "../models/pedido";
import { Produto, ProdutoDesconto } from "../models/produto";
import { Cliente } from "../models/cliente";
import { VendaEntrega } from "../models/venda-entrega";
import { Fornecedor } from "../models/fornecedor";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { Filtro } from "../models/filtro";
import { Marca } from "../models/marca";
import { KitFechado } from "../models/kit-fechado";
import { UsuarioLogado } from "../models/usuario-logado";
import { EstruturasPersonalizadas } from "../models/estruturas-personalizadas";
import { PrecificacaoUF } from "../models/precificacao-uf";
import { PremissasSistema } from "../models/premissas-sistema";
import { MenuProduto } from "../models/menuproduto";
import swal from "sweetalert2";
import { ClientesModalComponent } from "../modals/clientes-modal/clientes-modal.component";
import { MatCheckboxChange, MatDialog, PageEvent } from "@angular/material";
import { DetalheProdutoModalComponent } from "../modals/detalhe-produto-modal/detalhe-produto-modal.component";
import { DigitaCampoModalComponent } from "../modals/digita-campo-modal/digita-campo-modal.component";
import { MenuModel } from '../loja-gi/models/menu-model';
import { FiltroModel } from '../loja-gi/models/filtro-model';
import { LojaConfigService } from '../loja-gi/services/loja-config.service';
import { GiLojaModel } from '../dominio/gi-loja-model';
import { LojaService } from '../loja-gi/services/loja.service';
import { TipoSituacaoCadastral } from '../dominio/enums';
import { BreadCrumbModel } from '../loja-gi/models/bread-crumb-model';
import { forIn } from 'lodash';
import { PaginatedModel } from '../dominio/paginated-model';
import { PaginatorServiceV2 } from '../core/services/paginator-service-v2';
import { QueryFilterService } from '../core/services/query-filter-service';
import { OrigemGI, TipoFiltroProduto } from '../models/enum';
import { ProdutosModalComponent } from '../modals/produtos-modal/produtos-modal.component';
import { ProdutosV2ModalComponent } from '../modals/produtos-v2-modal/produtos-v2-modal.component';

// jquery
declare const $: any;

@Component({
  selector: 'app-loja-de-produtos',
  templateUrl: './loja-de-produtos.component.html',
  styleUrls: ['./loja-de-produtos.component.scss']
})
export class LojaDeProdutosComponent implements OnInit {
  limDesc = undefined;
  vendedor = undefined;
  calculadora = false;
  itens: ItemPedido[] = [];
  idOrcamento: string;
  orcamento: Pedido = new Pedido();
  producaoPorPainel: number;
  quantidadeDePaineis: number;
  potenciaPainel: number;
  potTotal: number;
  potenciaDesejada: number;
  fatorGeracao: number;
  descontosDoProduto: ProdutoDesconto[] = [];
  descontoParaAplicar = {
    valor: 0,
    fornecedor: undefined,
    idProduto: undefined,
  };
  descontoMaximo = 0;
  aplicacaoDescontoProgressivo = 0;
  clienteFaturamento: Cliente;
  confirmar = false;
  cancelado = false;
  administrador = false;
  intPodeAlterarCD = false;

  itemSemLote = false;

  integrador = false;
  cliente: Cliente;
  texto = 'Orçamento';
  potMin: number;
  potMax: number;
  filtrouPotencia = false;
  enderecoDeEntrega: VendaEntrega = new VendaEntrega();
  estadoSelecionado = undefined;
  cidadeSelecionado = undefined;
  pesoBruto = 0;
  multiFornecedores = false;
  calcularFrete = true;
  calcularDesconto = true;
  adicionarVariosKitPronto = false;

  vendaProgramada = false;
  comprovante: any;
  idProduto: number;
  pCentroDistribuicao = false;
  mostrarDescKit = true;
  pUsarAcrescimo = false;
  cds: Fornecedor[] = [];
  produtos: any[] = [];
  kits: any[] = [];
  potenciaParaFiltrar = undefined;
  potenciaParaFiltrarPainel = 0;
  itensFiltrados: ItemPedido[] = [];
  public config: PerfectScrollbarConfigInterface = {};

  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  carregando = true;
  listaDeItensPorPagina = [];
  itensPorPagina = 9;
  filtroNome: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtroCodBarra: Filtro = { Propriedade: 'codbarra', Valor: '' };
  filtroFamilia: Filtro = { Propriedade: 'familia', Valor: '' };
  filtros: Filtro[] = [this.filtroNome, this.filtroCodBarra];
  potenciaAte: number;
  marcasPainel: Marca[] = [];
  marcasInversor: Marca[] = [];
  marcaPainelSelecionada: any;
  marcaInversorSelecionada: any;
  telhados: any[] = [];
  telhadoSelecionado: any;
  ordenacoes = [{ id: 0, nome: 'Mais vendidos' }, { id: 1, nome: 'Maior valor' }, { id: 2, nome: 'Menor valor' }];
  ordenacaoSelecionada = 2;
  visualizacaoSelecionada = 0;
  kitsFechadosFiltrados: KitFechado[] = [];

  descontoFrete = undefined;
  clienteIntegrador = undefined;
  nome = undefined;
  calcValorFinalSugestao = false;
  usuarioLogado: UsuarioLogado;
  respostas = [];
  mostrarMsgTrocaCD = { valor: false, msg: '' };
  menusProduto = [];
  menuProdutoSelecionado = undefined;
  camposPersonalizados = [];
  categoriasDoMenu = [];
  categoriasMenuLateral = [];
  textoSelecionadoSubjects = {};
  faixaPreco = { min: 0, max: 0 };
  marcasProduto = [];
  marcasProdutoSelecionadas = new Set<number>();

  menus: MenuModel[] = [];
  filtrosMenu: FiltroModel[] = [];
  idMenuSelecionado;

  bloquearSistema: boolean = false;

  estruturasPersonalizadas: EstruturasPersonalizadas = new EstruturasPersonalizadas();

  precificacoesUF: PrecificacaoUF[] = [];

  premissasSistema: PremissasSistema;

  descAcresPrecificacaoUF: PrecificacaoUF;

  menuOrigem = 0;

  idLoja;
  loja: GiLojaModel;

  breadCrumbs: BreadCrumbModel[] = [];

  paginador: PaginatedModel;

  selectedFile: File;

  constructor(
    public dialog: MatDialog,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private produtoService: ProdutoService,
    private router: Router,
    private pedidoService: PedidoService,
    private clienteService: ClienteService,
    private notificacaoService: NotificacaoService,
    private premissasService: PremissasService,
    private logAcessoService: LogAcessoService,
    private utilitarioService: UtilitarioService,
    private marcaService: MarcaService,
    private segmentacaoService: SegmentacaoService,
    private fornecedorService: FornecedorService,
    private arquivoService: ArquivoService,
    private activatedRoute: ActivatedRoute,
    private menuProdutoService: MenuProdutoService,
    private campoPersonalizadoService: ProdutoCampoPersonalizadoService,
    private menuSelecionadoService: MenuSelecionadoService,
    private precificacaoUFService: PrecificacaoUFService,
    private lojaConfigService: LojaConfigService,
    private lojaService: LojaService,
    private paginatorServiceV2: PaginatorServiceV2,
    private queryFilterService: QueryFilterService
  ) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.idProduto =
        this.router.getCurrentNavigation().extras.state.idProduto;
    }

    this.activatedRoute.data.subscribe(data => {
      this.menuOrigem = data.origem;

      this.globalService.minimizarMenu();
    });
  }

  async ngOnInit() {
    this.activatedRoute.params.subscribe(async (params: Params) => {
      this.idLoja = +params['id'];
      await this.inicializacao();
    });
  }

  async inicializacao() {
    this.paginador = this.paginatorServiceV2.createInstance();

    await this.buscarPremissasSistema();
    await this.buscarPremissaCentroDeDistribuicao();
    await this.buscarMultiFornecedores();

    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.administrador = await this.globalService.administrador();
    this.integrador = await this.globalService.integrador();
    this.texto = this.integrador ? 'Orçamento' : 'Pedido';

    if (this.premissasSistema.usarPrecificacaoPorUF) {
      await this.buscarPrecificacoesUF();
    }

    await this.buscarLoja();
    await this.buscarMenus();

    if (this.integrador) {
      this.orcamento.cliente = this.usuarioLogado.id;
      this.buscarCliente();
    } else {
      if (!this.pCentroDistribuicao || this.multiFornecedores) {
        this.buscarProdutosLoja();
      }
    }

    this.orcamento.flag = 4;

    this.buscarPremissasBloqueioSistema();
    this.buscarPremissaUsarAcrescimo();
  }

  selecionarItem(menu: MenuProduto) {
    if (menu.campoPersonalizado === null || menu.campoPersonalizado === undefined) return;
    this.menuSelecionadoService.selecionarMenu(menu.idMenu);
  }

  buscarPremissasBloqueioSistema() {
    this.carregandoService.mostra('buscarBloqSist');
    this.premissasService.consultarBloqSistManuProd().subscribe(data => {
      this.bloquearSistema = data;
      this.carregandoService.esconde('buscarBloqSist');
    }, (erro) => {
      this.carregandoService.esconde('buscarBloqSist');
      this.notificacaoService.erro(erro);
    });
  }

  buscarPremissaUsarAcrescimo() {
    this.carregandoService.mostra('buscarPremissaUsarAcrescimo');
    this.premissasService.consultarUsarAcrescimo().subscribe(f => {
      if (f.valor) {
        this.pUsarAcrescimo = true;
      }

      this.carregandoService.esconde('buscarPremissaUsarAcrescimo');
    }, (erro) => {
      this.carregandoService.esconde('buscarPremissaUsarAcrescimo');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  async buscarPrecificacoesUF() {
    try {
      this.carregandoService.mostra('buscarPrecificacoesUF');
      this.precificacoesUF = await this.precificacaoUFService.consultar().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPrecificacoesUF');
    }
  }

  async buscarLoja() {
    try {
      this.carregandoService.mostra('buscarLoja');
      this.loja = (await this.lojaConfigService.buscarPorId(this.idLoja).toPromise()).result;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarLoja');
    }
  }

  async buscarMenus() {
    try {
      this.carregandoService.mostra('buscarMenus');
      this.menus = (await this.lojaService.buscarMenus(this.idLoja).toPromise()).results;
      if (this.menus.length > 0) {
        await this.selecionarMenuProduto(this.menus[0], false);
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarMenus');
    }
  }

  async buscarBreadCrumbs() {
    try {
      this.carregandoService.mostra('buscarBreadCrumbs');
      this.breadCrumbs = (await this.lojaService.buscarBreadCrumbs(this.idLoja, this.idMenuSelecionado === this.menus[0].id ? null : this.idMenuSelecionado).toPromise()).results;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarBreadCrumbs');
    }
  }

  async selecionarBreadCrumb(breadCrumb: BreadCrumbModel) {

    if (breadCrumb.ativo) return;

    const menu = this.buscarMenuRecursivo(breadCrumb.id, this.menus);
    await this.selecionarMenuProduto(menu, true);
  }

  buscarMenuRecursivo(idMenu: number, menus: MenuModel[]): MenuModel {
    for (const menu of menus) {
      if (menu.id === idMenu)
        return menu;
      else if (menu.filhos && menu.filhos.length > 0) {
        return this.buscarMenuRecursivo(idMenu, menu.filhos);
      }
    }

    return undefined;
  }

  montarFiltros() {
    const filtrosSelecionados = this.filtrosMenu
      .filter((p) => p.idItemSelecionado)
      .map((p) => {
        return { idMenu: p.id, idItemSelecionado: p.idItemSelecionado };
      });

    return filtrosSelecionados && filtrosSelecionados.length > 0
      ? filtrosSelecionados.map((p) => `tabela_${p.idMenu}__item_${p.idItemSelecionado}`)
      : null;
  }

  async buscarFiltros() {

    if (!this.integrador && this.pCentroDistribuicao && !this.validarIntegradorCentroDistribuicao()) {
      this.categoriasMenuLateral = [];
      return;
    }

    const idCD = this.cliente ? this.cliente.idCD : undefined;

    if (this.pCentroDistribuicao && !idCD) {
      return;
    }

    try {
      this.carregandoService.mostra('buscarFiltros');

      this.filtrosMenu = (await this.lojaService.buscarFiltros(this.idLoja, this.idMenuSelecionado, idCD, true, this.montarFiltros()).toPromise()).results;

      this.filtrosMenu.forEach(p => {
        if (p.aplicado) {
          p.idItemSelecionado = p.itens[0].id;
        }
      });

      this.buscarProdutosLoja();

    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarFiltros');
    }
  }

  buscarCDs() {
    this.carregandoService.mostra('buscarCDs');

    this.fornecedorService.consultarFornecedores().subscribe(
      (forn) => {
        this.cds = forn;
        this.carregandoService.esconde('buscarCDs');
      },
      (err) => {
        this.carregandoService.esconde('buscarCDs');
        this.notificacaoService.erro(err);
      }
    );
  }

  async buscarPremissaCentroDeDistribuicao() {
    try {
      this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');

      this.pCentroDistribuicao = (await this.premissasService.consultarCentroDeDistribuicao().toPromise()).valor;

      if (this.pCentroDistribuicao) {
        this.buscarIntPodeAlterarCD();
        this.buscarCDs();
      }

      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');

    } catch (erro) {
      this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
      this.notificacaoService.erro(erro);
    }
  }

  async buscarMultiFornecedores() {
    try {
      this.carregandoService.mostra('buscarMultiFornecedores');

      this.multiFornecedores = (await this.premissasService.consultarMultiFornecedores().toPromise()).valor;

      this.carregandoService.esconde('buscarMultiFornecedores');

    } catch (erro) {
      this.carregandoService.esconde('buscarMultiFornecedores');
      this.notificacaoService.erro(erro);
    }
  }

  buscarCliente() {
    this.carregandoService.mostra('buscaClientes');
    this.clienteService
      .consultarPorIdCliente(this.orcamento.cliente, true)
      .subscribe(
        async (cli) => {

          this.itens = [];

          this.cliente = cli;

          if (this.premissasSistema.usarPrecificacaoPorUF) {
            this.estadoSelecionado = this.cliente.uf;
            this.cidadeSelecionado = this.cliente.ibge;

            this.descAcresPrecificacaoUF = this.precificacoesUF.some((p) => p.uf === this.estadoSelecionado)
              ? this.precificacoesUF.find((p) => p.uf === this.estadoSelecionado)
              : { percentual: 0, uf: "", tipoDa: 0 };
          }

          this.buscarProdutosLoja();

          this.carregandoService.esconde("buscaClientes");
        },
        (erro) => {
          this.carregandoService.esconde("buscaClientes");
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarProdutosLoja() {
    if (!this.integrador && this.pCentroDistribuicao && !this.validarIntegradorCentroDistribuicao()) {
      this.categoriasMenuLateral = [];
      return;
    }

    const idCD = this.cliente ? this.cliente.idCD : undefined;

    if (this.pCentroDistribuicao && !idCD) {
      return;
    }

    this.carregandoService.mostra('buscarProdutosLoja');

    const queryFilter = this.queryFilterService.getQueryBuilder()
      .setPage(this.paginador.page)
      .setPageSize(this.paginador.pageSize)
      .build();

    this.lojaService.buscarProdutos(this.idLoja, this.idMenuSelecionado === this.menus[0].id ? null : this.idMenuSelecionado, this.cliente && this.pCentroDistribuicao ? this.cliente.idCD : undefined, this.montarFiltros(), queryFilter).subscribe(
      result => {
        let produtos = result.results;

        this.paginador = this.paginatorServiceV2.createInstance(result.pagination);

        this.itensFiltrados = [];
        // this.marcasProduto = result.marcas;

        produtos.forEach(p => {
          const novoItem = new ItemPedido();
          novoItem.pUnitario = p.precoAvulso;
          novoItem.pCusto = p.precoCusto;
          novoItem.produto = p.idProduto;
          novoItem.produtoTela = p;
          novoItem.det1 = p.descricaoAtual;
          novoItem.pVendaOriginal = novoItem.pUnitario;

          if (this.calcValorFinalSugestao && (this.integrador || (this.cliente !== null && this.cliente !== undefined))) {
            novoItem.pUnitarioSugerido = p.precoFinalSugerido;
          }

          if (p.multiplo && p.valorMultiplo > 0) {
            novoItem.qt = p.valorMultiplo;
          } else {
            novoItem.qt = 1;
          }

          this.itensFiltrados.push(novoItem);
        });

        this.itensFiltrados.forEach((kit: ItemPedido) => {
          kit.imagem$ = this.buscarImagemProduto(kit.produtoTela);
          kit.imagem$.then(p => { kit.buscouImagem = true; });
        });

        // this.listaDeItensPorPagina = this.utilitarioService
        //   .calculaItensPorPagina(result.total);

        // if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        //   this.itensPorPagina = 10;
        // }

        // this.paginacao.total = result.total;

        this.carregandoService.esconde('buscarProdutosLoja');
      },
      (erro) => {
        this.carregandoService.esconde('buscarProdutosLoja');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarProdutosPorReferencia() {
    const dados = new FormData();
    dados.append('arquivo', this.selectedFile);
    this.carregandoService.mostra('buscarProdutosPorReferencia');
    this.lojaService.buscarProdutosPorReferencia(this.idLoja, this.cliente && this.pCentroDistribuicao ? this.cliente.idCD : undefined, dados).subscribe((resp) => {
      this.carregandoService.esconde('buscarProdutosPorReferencia');
      this.notificacaoService.sucesso('Itens adicionados com sucesso!!!');

      this.limparArquivo();

      resp.results.forEach(p => {

        const produtoNaLista = this.itens.find(pi => pi.produto === p.produto);

        if (produtoNaLista) {
          produtoNaLista.qt = p.qt;
          this.validaQtd(produtoNaLista, true, true);
        } else {
          p.pVendaOriginal = p.pUnitario;
          this.itens = [...this.itens, p];
          this.validaQtd(p, true, true);
        }
      });
    },
      (erro) => {
        this.limparArquivo();
        this.carregandoService.esconde('buscarProdutosPorReferencia');
        this.notificacaoService.erro(erro);
      });
  }

  trocarCD() {
    if (this.itens === null || this.itens === undefined || this.itens.length === 0) {
      return;
    }

    this.carregandoService.mostra('trocarCD');
    this.carregando = true;

    this.produtoService.trocarCD(this.itens.map(p => p.produto).join(','), true, this.cliente.idCD, '7').subscribe(dados => {
      const produtos: Produto[] = dados;

      const itensAtualizados: ItemPedido[] = [];

      produtos.forEach(p => {
        const novoItem = this.itens.find(i => i.produto === p.idProduto);
        novoItem.pUnitario = p.precoAvulso;
        novoItem.pCusto = p.precoCusto;
        novoItem.produto = p.idProduto;
        novoItem.produtoTela = p;
        novoItem.det1 = p.descricaoAtual;
        novoItem.pVendaOriginal = novoItem.pUnitario;

        itensAtualizados.push(novoItem);
      });

      this.itens = [...itensAtualizados];

      this.itens.forEach(async i => await this.atualizaValorProduto(i));

      this.carregando = false;
      this.carregandoService.esconde('trocarCD');
    }, () => {
      this.carregandoService.esconde('trocarCD');
    });
  }

  substituirVirgulaPorPonto(valor) {
    return valor.toString().replace(/,/g, '.');
  }

  async buscarImagemProduto(produto: Produto): Promise<string> {
    const imagem = await this.produtoService.consultarImagemProdutoPorId(produto.idProduto).toPromise();

    if (imagem && imagem.url) {
      return Promise.resolve(imagem.url);
    } else if (imagem && imagem.raw) {
      return Promise.resolve('data:image/jpg;base64,' + imagem.raw);
    } else {
      return Promise.resolve('./assets/img/sem-foto.jpg');
    }
  }

  alterarVisualizacao(visualizacao: number) {
    const buscarProdutos = (this.visualizacaoSelecionada === 2 && visualizacao !== 2) || (this.visualizacaoSelecionada !== 2 && visualizacao === 2);

    this.visualizacaoSelecionada = visualizacao;

    if (buscarProdutos) {
      this.buscarProdutosLoja();
    }
  }

  abrirKit(kit: any) {
    kit.kitAberto = true;
  }

  validarPotencias() {
    const isNullOrUndefined = (value: any) => value === null || value === undefined;

    if (!isNullOrUndefined(this.faixaPreco.min) && !isNullOrUndefined(this.faixaPreco.max)) {
      if (Number(this.faixaPreco.min) > Number(this.faixaPreco.max)) {
        this.notificacaoService.erro('A faixa de preço mínimo deve ser menor que a faixa de preço máximo.');
        this.faixaPreco.max = Number(this.faixaPreco.min);
      }
    }
  }

  async selecionarMenuProduto(menu: MenuModel, buscarProdutos: boolean) {

    if (menu !== undefined && menu !== null && menu.navegavel) {
      this.idMenuSelecionado = menu.id;
      this.filtrosMenu = [];
      await this.buscarFiltros();
      await this.buscarBreadCrumbs();

      this.itensFiltrados = [];

      if (buscarProdutos)
        this.buscarProdutosLoja();

    }

    return;

    // if (menu.campoPersonalizado === null || menu.campoPersonalizado === undefined) return;

    // this.menuProdutoSelecionado = menu;

    // this.categoriasMenuLateral =
    //   this.camposPersonalizados
    //     .filter(c => menu
    //       .categoriasMenuLateral
    //       .some(cp => cp === c.id));


  }

  buscarIntPodeAlterarCD() {
    this.carregandoService.mostra('buscarIntPodeAlterarCD');
    this.premissasService.consultarIntPodeAlterarCD().subscribe(
      (f) => {
        this.intPodeAlterarCD = f.valor;

        if (this.intPodeAlterarCD) {
          this.buscarMostrarMsgTrocaCD();
        }

        this.carregandoService.esconde('buscarIntPodeAlterarCD');
      },
      (erro) => {
        this.carregandoService.esconde('buscarIntPodeAlterarCD');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMostrarMsgTrocaCD() {
    this.carregandoService.mostra('buscarMostrarMsgTrocaCD');
    this.premissasService.consultarMostrarMsgTrocaCD().subscribe(
      (f) => {
        this.mostrarMsgTrocaCD = f;
        this.carregandoService.esconde('buscarMostrarMsgTrocaCD');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMostrarMsgTrocaCD');
        this.notificacaoService.erro(erro);
      }
    );
  }

  validarIntegradorCentroDistribuicao() {
    if (!this.cliente) {
      swal({
        title: 'Atenção!!',
        text: 'Selecione um integrador para continuar...',
        type: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonClass: 'btn btn-danger',
        cancelButtonText: 'Fechar',
        buttonsStyling: false
      }).then(() => {
        this.itensFiltrados = [];
        this.itens = [];
        this.kitsFechadosFiltrados = [];
        return false;
      });
    } else {
      if (!this.cliente.idCD) {
        swal({
          title: 'Atenção!!',
          text: 'Cadastro do integrador incompleto falta (Centro de Distribuição), atualize!',
          type: 'warning',
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonClass: 'btn btn-danger',
          cancelButtonText: 'Fechar',
          buttonsStyling: false
        }).then(() => {
          this.itensFiltrados = [];
          this.itens = [];
          this.kitsFechadosFiltrados = [];
          return false;
        });
      } else {
        return true;
      }
    }
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: { cliente: Cliente, vendedor: any, limDesc: any }) => {
      if (result) {
        this.itens = [];
        this.descontoFrete = result.cliente.descFrete;
        this.cliente = result.cliente;
        this.clienteIntegrador = result.cliente;
        this.descontoMaximo = this.usuarioLogado.limDesc;

        this.vendedor = result.vendedor;
        this.limDesc = result.limDesc;

        if (this.premissasSistema.usarPrecificacaoPorUF) {
          this.estadoSelecionado = this.cliente.uf;
          this.cidadeSelecionado = this.cliente.ibge;

          this.descAcresPrecificacaoUF = this.precificacoesUF.some(p => p.uf === this.estadoSelecionado) ?
            this.precificacoesUF.find(p => p.uf === this.estadoSelecionado) : { percentual: 0, uf: '', tipoDa: 0 };
        }


        if (this.pCentroDistribuicao || this.calcValorFinalSugestao) {
          this.selecionarMenuProduto(this.buscarMenuRecursivo(this.idMenuSelecionado, this.menus), true);
          // this.buscarProdutosLoja();

          if (this.itens !== null && this.itens !== null && this.itens.length > 0) {
            this.itens.forEach(async p => await this.atualizaValorProduto(p));
          }
        }
      }
    }
    );
  }

  async atualizaValorProduto(item: ItemPedido) {
    if (
      this.descontosDoProduto.some(
        (p) =>
          p.produto === item.produtoTela.idProduto &&
          Number(item.qt) >= Number(p.qtdIni) &&
          Number(item.qt) <= Number(p.qtdFim)
      )
    ) {
      this.descontoParaAplicar.valor = this.descontosDoProduto.find(
        (p) =>
          p.produto === item.produtoTela.idProduto &&
          Number(item.qt) >= Number(p.qtdIni) &&
          Number(item.qt) <= Number(p.qtdFim)
      ).desco;

      this.descontoParaAplicar.fornecedor = item.produtoTela.fornecedor;
      this.descontoParaAplicar.idProduto = item.produto;

      if (this.aplicacaoDescontoProgressivo === 0) {
        this.itens.forEach(async (p) => {
          if (p.produtoTela.idProduto !== item.produtoTela.idProduto) {
            await this.atualizaValorProduto(p);
          }
        });
      }
    } else if (
      this.descontoParaAplicar.valor !== 0 &&
      this.descontosDoProduto.some(
        (p) => p.produto === item.produtoTela.idProduto
      ) &&
      !this.descontosDoProduto.some(
        (p) =>
          p.produto === item.produtoTela.idProduto &&
          Number(item.qt) >= Number(p.qtdIni) &&
          Number(item.qt) <= Number(p.qtdFim)
      )
    ) {
      this.descontoParaAplicar.valor = 0;
      this.descontoParaAplicar.idProduto = item.produto;

      if (this.aplicacaoDescontoProgressivo === 0) {
        this.itens.forEach(async (p) => {
          if (p.produtoTela.idProduto !== item.produtoTela.idProduto) {
            await this.atualizaValorProduto(p);
          }
        });
      }
    }

    item.pUnitario =
      item.produto === this.descontoParaAplicar.idProduto ||
        this.aplicacaoDescontoProgressivo === 0
        ? item.produtoTela.precoAvulso -
        (item.produtoTela.precoAvulso * this.descontoParaAplicar.valor) / 100
        : item.produtoTela.precoAvulso;

    item.pUnitario = this.calcularPrecificacao(item.pUnitario);

    item.vTotal = item.pUnitario * item.qt;

    if (this.calcValorFinalSugestao && (this.integrador || (this.cliente !== null && this.cliente !== undefined))) {
      item.vTotalSugerido = await this.calcularValorFinal(item.pUnitario * item.qt, Number(item.produtoTela.potencia));
    }

    this.atualizaValores();
  }

  calcularPrecificacao(precoUnitario: number) {

    const precoBase = precoUnitario;

    if (this.premissasSistema.usarPrecificacaoPorUF) {
      precoUnitario = this.precificacaoUFService.calcularPrecificacaoUF(precoBase, this.descAcresPrecificacaoUF);
    }

    if (this.premissasSistema.habilitarPrecificacaoPorIntegrador && this.cliente) {
      precoUnitario = this.precificacaoUFService.calcularPrecificacaoIntegrador(precoUnitario, precoBase, this.cliente.tipoPrecificacao, this.cliente.valorPrecificacao);
    }

    return precoUnitario;
  }

  async calcularValorFinal(valor: number, potencia: number) {
    try {
      this.carregandoService.mostra('buscarPremissaCalcValorFinalSugestao');

      return (await this.pedidoService.calcularValorFinal(!this.integrador ? (this.cliente !== null && this.cliente !== undefined ? this.cliente.id : null) : this.usuarioLogado.id, 1, valor, this.cliente && this.pCentroDistribuicao ? this.cliente.idCD : undefined, potencia / 1000, false, null, null, this.cidadeSelecionado).toPromise());

    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissaCalcValorFinalSugestao');
    }
  }

  atualizaValores() {
    let valortotal = 0;

    this.orcamento.valorTotal = Number(this.itens.reduce((acc, curr) => (acc + (Number(curr.pUnitario) * Number(curr.qt))), 0).toFixed(2));

    if (this.orcamento.valorDa !== undefined) {
      if (this.orcamento.da === 0) {
        this.orcamento.valorFinal = Number(
          (this.orcamento.valorTotal - this.orcamento.valorDa).toFixed(2)
        );
      } else {
        this.orcamento.valorFinal = Number(
          (this.orcamento.valorTotal + this.orcamento.valorDa).toFixed(2)
        );
      }
    } else {
      this.orcamento.valorFinal = this.orcamento.valorTotal;
    }
    this.calcularPesoBruto();
  }

  calcularPesoBruto() {
    this.pesoBruto = 0;
    this.itens.forEach((element: any) => {
      this.pesoBruto += element.produtoTela.peso
        ? element.produtoTela.peso * element.qt
        : 0;
    });
  }

  async selecionarProduto(produto?) {
    // this.rolarParaFimDaPagina();

    const produtoNaLista = this.itens.find(p => p.produtoTela.idProduto === produto.produtoTela.idProduto);

    if (produtoNaLista) {
      swal({
        title: 'ATENÇÃO!!!',
        html: 'Este produto já está no carrinho!!!',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-warning',
        type: 'warning'
      }).catch(swal.noop);
    } else {
      // if (produto.produtoTela.multiplo && produto.produtoTela.valorMultiplo > 0) {
      //   produto.qt = produto.produtoTela.valorMultiplo;
      // }
      // else {
      //   produto.qt = 1;
      // }

      // produto.pVendaOriginal = produto.pUnitario;
      this.itens = [...this.itens, produto];
      await this.atualizaValorProduto(this.itens.find(p => p.produtoTela.idProduto === produto.produtoTela.idProduto));
    }
  }

  rolarParaFimDaPagina() {
    const element = document.getElementById('tabelaItensSelecionados');

    element.scrollIntoView();
  }

  detalhesDoProduto(produto: Produto) {
    this.dialog.open(DetalheProdutoModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        produto: produto,
        buscarClassificacao: true,
        origemGI: OrigemGI.LojaProdutos
      },
      panelClass: 'modal-card',
      maxHeight: '90vh',
    });
  }



  mudaDePagina(pageEvent: PageEvent) {
    this.paginador.page = pageEvent.pageIndex + 1;
    this.paginador.pageSize = this.paginatorServiceV2.setPageSize(pageEvent.pageSize);

    this.buscarProdutosLoja();
  }

  async validaQtd(item: ItemPedido, atualizarValor: boolean, forcarAtualizacao?: boolean) {
    if (
      item.qt === null ||
      item.qt === undefined ||
      Number.isNaN(Number(item.qt)) ||
      Number(item.qt) < 0
    ) {
      item.qt = item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0 ? item.produtoTela.valorMultiplo : 1;

      if (atualizarValor)
        await this.atualizaValorProduto(item);

    } else if (Number(item.qt) > 100000) {
      item.qt = item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0 ?
        this.utilitarioService.multiploOuMaisProximo(Number(item.qt), item.produtoTela.valorMultiplo, item.produtoTela.valorMultiplo, 100000, 'down') : 100000;

      if (atualizarValor)
        await this.atualizaValorProduto(item);

    } else if (item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0) {

      item.qt = this.utilitarioService.multiploOuMaisProximo(Number(item.qt), item.produtoTela.valorMultiplo, item.produtoTela.valorMultiplo, 100000, 'up');

      if (atualizarValor)
        await this.atualizaValorProduto(item);
    }

    if (forcarAtualizacao) {
      await this.atualizaValorProduto(item);
    }
  }

  salvarOrcamento(tipo: any) {
    let potTotal = 0;

    let da: number;
    let percentual: number;
    let valorDa: number;

    if (this.calcularDesconto && this.pUsarAcrescimo && this.cliente.daGI === 1) {
      da = 1;
      percentual = this.cliente.acrescimoGI;
      valorDa = Number(
        (
          (Number(this.orcamento.valorTotal) * this.cliente.acrescimoGI) /
          100
        ).toFixed(2)
      );
    }

    let idFornecedor = null;

    if (this.pCentroDistribuicao) {
      idFornecedor = this.cliente.idCD;
    }

    if (this.multiFornecedores) {
      idFornecedor = this.orcamento.painelProduto.idFornecedor;
    }

    let qtModulos = 0;

    if (this.premissasSistema.usaDescargaCif) {
      qtModulos = this.itens.reduce((total, it) => {
        if (it.produtoTela.familia === 2) {
          return total + it.qt;
        }
        if (it.produtoTela.familia === 7) {
          return total + it.produtoTela.composicao.reduce((compTotal, comp) => {
            return comp.produtoMP.familia === 2 ? compTotal + (comp.qt * it.qt) : compTotal;
          }, 0);
        }
        return total;
      }, 0);
    }

    const valorProdutos = this.itens.reduce((total, p) => {
      const preco = p.pUnitario * p.qt; // (p && p.produtoTela && p.produtoTela.precoAvulso) ? (p.produtoTela.precoAvulso * p.qt) : 0;
      return total + preco;
    }, 0);

    this.itens.forEach(async (i) => { i.produtoTela.precoVenda = i.pVendaOriginal; });

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(DigitaCampoModalComponent, {
      width: largura > 1030 ? '1000px' : $('body').width().toString() + 'px',

      // passa os produtos já selecionados
      data: {
        origem: 3,
        tipo: tipo,
        selecionarIntegrador: !this.integrador,
        informarNome: !this.nome,
        nome: this.nome,
        descontoFrete: this.descontoFrete,
        cliente: this.cliente,
        clienteIntegrador: this.clienteIntegrador,
        descontoMaximo: this.descontoMaximo,
        valorProdutos: valorProdutos,
        ibge: this.cliente ? this.cliente.ibge : '',
        calculadora: this.calculadora,
        uf: this.estadoSelecionado,
        cidade: this.cidadeSelecionado,
        naoCalcularFrete: !this.calcularFrete,
        naoCalcularDesconto: !this.calcularDesconto,
        idDescarga: this.orcamento.idDescarga,
        limDesc: this.limDesc,
        vendedor: this.vendedor ? this.vendedor : (!this.integrador ? { idFuncion: this.usuarioLogado.id, nome: this.usuarioLogado.nome } : null),
        idCD: this.pCentroDistribuicao
          ? this.cliente.idCD
          : (this.multiFornecedores && this.orcamento.painelProduto !== null && this.orcamento.painelProduto !== undefined ? this.orcamento.painelProduto.idFornecedor : undefined),
        potencia: potTotal,
        da: da,
        percentual: percentual,
        valorDa: valorDa,
        valorTotalFixo: this.orcamento.valorTotalFixo,
        descAcresPrecificacaoUF: this.descAcresPrecificacaoUF,
        itens: JSON.parse(JSON.stringify(this.itens)),
        idFornecedor: idFornecedor,
        qtModulos: qtModulos
      },
      panelClass: 'modal-card',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.orcamento.comprador = result.nome;
        this.pedidoService.setFormaPagPedido(this.orcamento, result.formaPagamento);
        this.pedidoService.setCondPagPedido(this.orcamento, result.condicaoPagamento);

        if (tipo !== 0) {
          this.orcamento.vendaDireta = result.vendaDireta;
          this.clienteFaturamento = result.clienteFaturamento;
        }

        this.respostas = result.respostas;

        this.itens = JSON.parse(JSON.stringify(result.itens));

        // this.itens.forEach(async (i) => { i.pUnitario = i.produtoTela.precoAvulso; })

        this.descAcresPrecificacaoUF = result.descAcresPrecificacaoUF;
        this.orcamento.valorTotal = result.valorProdutos;

        this.orcamento.obs2 = result.enderecoEntregaCompleto;

        this.orcamento.txLocalizacao = result.txLocalizacao;
        this.orcamento.tipoLocalizacao = result.localizacao;
        this.orcamento.da = result.da;
        this.orcamento.valorDa = Number(result.valorDa);
        this.orcamento.percentual = Number(result.percentual);
        this.orcamento.tipoFrete = Number(result.tipoFrete);
        this.orcamento.frete = Number(result.valorFrete);
        this.orcamento.entrega = Number(result.entrega);
        this.orcamento.taxaDA = Number(result.taxaDA);
        this.enderecoDeEntrega = result.enderecoEntrega;
        this.enderecoDeEntrega.ibge = Number(this.enderecoDeEntrega.ibge);

        this.orcamento.origemGI = 3;

        this.orcamento.idDescarga = result.idDescarga === null || result.idDescarga === undefined ? null : Number(result.idDescarga);

        this.orcamento.transportadora = result.idTransportadora;

        this.orcamento.valorServico = Number(result.valorServico);
        this.orcamento.valorServicoLiquido = Number(result.valorLiquido);

        this.orcamento.freteManual = result.freteManual;

        this.orcamento.formasPagamento = result.formasPagamento;

        this.orcamento.seguros = result.seguros;
        this.orcamento.servicoEntrega = result.servicoEntrega;
        this.orcamento.valorServicoEntrega = result.valorServicoEntrega;
        this.orcamento.servicoEntregaManual = result.servicoEntregaManual;

        this.orcamento.valorProjeto = result.valorProjeto;
        this.orcamento.valorProjetoLiquido = result.valorProjetoLiquido;
        this.orcamento.tipoCIF = result.tipoCIF;

        if (!this.integrador) {
          this.orcamento.cliente = result.cliente.id;
        }

        this.orcamento.valorTotalFixo = result.valorTotalFixo;

        this.orcamento.idFrete = result.idFrete;

        this.orcamento.multiFormaPagamento = result.usandoMultiFormasPagamento;

        this.comprovante = result.comprovante;
        this.confirmar = result.confirmar;

        this.orcamento.voucher = result.voucher;
        this.orcamento.dadosVoucher = result.dadosVoucher;
        this.orcamento.valorVoucher = result.valorVoucher;

        this.orcamento.impostos = result.impostos;
        this.orcamento.valorImpostos = result.valorImpostos;
        this.orcamento.impostosPendente = result.impostosPendente;

        this.salvarPedido(tipo);
      }
    });
  }

  salvarPedido(tipo) {
    this.carregandoService.mostra('salvaPedido');

    const vendedorSelecionado = this.vendedor ? this.vendedor.idFuncion : this.usuarioLogado.id;

    this.orcamento.vendedor = this.integrador
      ? this.cliente.vendedor
      : vendedorSelecionado;
    this.orcamento.indicacao = 0;
    this.orcamento.nItens = this.itens.length;
    this.orcamento.troco = 0;
    this.orcamento.nParcelas = 1;
    this.orcamento.gTotal = 0;
    this.orcamento.nCartao = '1';
    this.orcamento.bc = 0;
    this.orcamento.ext = 0;
    this.orcamento.nECF = '0';
    this.orcamento.turno = 0;
    this.orcamento.nTurno = 0;
    this.orcamento.status = 0;
    this.orcamento.nPdv = 95;
    this.orcamento.nLoja = 1;
    this.orcamento.funcDesco = 0;
    this.orcamento.data = new Date();

    this.orcamento.idLoja = this.idLoja;

    if (this.multiFornecedores) {
      this.orcamento.idFornecedor = this.itens[0].produtoTela.idFornecedor;
    }

    if (this.pCentroDistribuicao) {
      this.orcamento.idFornecedor = this.cliente.idCD;
    }

    this.itens.forEach((it) => {
      it.nItem = this.itens.indexOf(it) + 1;
      it.cc = it.produtoTela.cc;
      it.comissao = 0;
      it.da = 0; // se tiver desconto é 0
      it.valorDa = 0;
      it.frete = 0;
      it.pCusto = it.produtoTela.precoCusto;
      it.percentual = 0;
      it.idCupom = this.idOrcamento ? this.idOrcamento : it.idCupom;
    });

    this.salvar(tipo);
  }

  salvar(tipo) {
    this.itens.forEach(p => { p.pVendaOriginal = p.produtoTela.precoAvulso; });

    if (tipo === 1 && this.confirmar) {
      this.pedidoService.confirmarOrcamento(this.orcamento,
        this.itens,
        [],
        this.orcamento.vendaDireta ? this.clienteFaturamento : null,
        false,
        tipo === 0 ? true : false,
        false,
        this.enderecoDeEntrega, this.comprovante, this.respostas).subscribe((resp: any) => {
          this.idOrcamento = resp.idCupom;
          this.carregandoService.esconde('salvaPedido');
          this.notificacaoService.sucesso('Pedido Confirmado com sucesso!!!');
          this.router.navigate(['/pedidos']);
        }, (erro) => {
          this.carregandoService.esconde('salvaPedido');
          this.notificacaoService.erro(erro);

          this.definirItemSemLote(erro);
        });
    } else {
      this.pedidoService
        .salvar(
          this.orcamento,
          this.itens,
          [],
          this.orcamento.vendaDireta ? this.clienteFaturamento : null,
          false,
          tipo === 0 ? true : false,
          false,
          this.enderecoDeEntrega,
          this.respostas
        )
        .subscribe(
          (resp: any) => {
            this.idOrcamento = resp.idCupom;
            this.notificacaoService.sucesso((tipo === 0 ? 'Orçamento' : 'Pedido') + ' Salvo com sucesso!!!');
            this.carregandoService.esconde('salvaPedido');
            this.router.navigate([tipo === 0 ? '/orcamentos' : '/pedidos']);
          },
          (erro) => {
            this.carregandoService.esconde('salvaPedido');
            this.notificacaoService.erro(erro);
            this.definirItemSemLote(erro);
          }
        );
    }
  }

  definirItemSemLote(erro) {
    this.itemSemLote = false;

    if (this.vendaProgramada && erro.error && erro.error.itemSemLote) {
      this.itemSemLote = true;

      this.itens.forEach(p => {
        p.produtoTela.semLote = false;

        if (p.produto === erro.error.itemSemLote) {
          p.produtoTela.semLote = true;
        } else if (p.produtoTela.composicao) {
          p.produtoTela.composicao.forEach(c => {
            c.produtoMP.semLote = false;

            if (c.proMP === erro.error.itemSemLote) {
              p.produtoTela.semLote = true;
              c.produtoMP.semLote = true;
            }
          });
        }
      });
    }
  }

  async aumentaQtdProduto(item: ItemPedido) {
    const incremento = item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0 ? item.produtoTela.valorMultiplo : 1;
    const novaQuantidade = Number(item.qt) + incremento;

    if (novaQuantidade <= 100000) {
      item.qt = novaQuantidade;
      await this.atualizaValorProduto(item);
    }
  }

  async diminuiQtdProduto(item: ItemPedido) {
    const decremento = item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0 ? item.produtoTela.valorMultiplo : 1;
    const novaQuantidade = Number(item.qt) - decremento;

    if (novaQuantidade >= 1) {
      item.qt = novaQuantidade;
      await this.atualizaValorProduto(item);
    }
  }

  excluirProduto(item: ItemPedido) {
    item.qt = item.produtoTela.multiplo && item.produtoTela.valorMultiplo > 0 ? item.produtoTela.valorMultiplo : 1;
    this.itens.splice(this.itens.indexOf(item), 1);

    if (
      this.descontosDoProduto.some(
        (p) =>
          p.produto === item.produtoTela.idProduto &&
          Number(item.qt) >= Number(p.qtdIni) &&
          Number(item.qt) <= Number(p.qtdFim)
      )
    ) {
      this.descontoParaAplicar.valor = 0;
      this.descontosDoProduto = [];
      this.itens.forEach(async (p) => {
        if (p.produtoTela.idProduto !== item.produtoTela.idProduto) {
          await this.atualizaValorProduto(p);
        }
      });
    }

    this.atualizaValores();
  }

  itemNoCarrinho(item: ItemPedido) {
    return this.itens.some(p => p.produto === item.produto);
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    this.buscarProdutosPorReferencia();
  }

  limparArquivo() {
    const element = document.getElementById('inputImportar_id') as HTMLInputElement;
    if (element) {
      element.value = '';
    }
  }

  baixarModelo() {
    this.carregandoService.mostra('baixarArquivo');
    this.lojaService.baixarModelo(this.idLoja).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, 'modelo_importacao_itens.xlsx');
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  pesquisarProdutos() {
    let dialogRef;
    let idFornecedor = null;

    if (this.pCentroDistribuicao) {
      idFornecedor = this.cliente.idCD;
    }

    const config = {
      width: ($('body').width()).toString() + 'px',
      // passa os produtos já selecionados
      data: {
        descAcresPrecificacaoUF: this.descAcresPrecificacaoUF,
        selecionavel: true,
        produtos: this.itens,
        somenteKit: false,
        producaoPorPainel: 0,
        quantidadeDePaineis: 0,
        potenciaPainel: 0,
        potTotal: 0,
        origem: 3,
        semKit: true,
        idLoja: this.idLoja,
        cliente: this.cliente,
        idFornecedorPainel: idFornecedor,
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    };

    if (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(ProdutosModalComponent, config);
    } else {
      dialogRef = this.dialog.open(ProdutosV2ModalComponent, config);
    }

    // quando fecha o modal
    dialogRef.afterClosed().subscribe((result: ItemPedido[]) => {
      if (result) {
        result.forEach(p => {
          const novoItem = new ItemPedido();
          novoItem.pUnitario = p.produtoTela.precoAvulso;
          novoItem.pCusto = p.produtoTela.precoCusto;
          novoItem.produto = p.produtoTela.idProduto;
          novoItem.produtoTela = p.produtoTela;
          novoItem.det1 = p.produtoTela.descricaoAtual;
          novoItem.pVendaOriginal = novoItem.pUnitario;

          if (this.calcValorFinalSugestao && (this.integrador || (this.cliente !== null && this.cliente !== undefined))) {
            novoItem.pUnitarioSugerido = p.produtoTela.precoFinalSugerido;
          }

          if (p.produtoTela.multiplo && p.produtoTela.valorMultiplo > 0) {
            novoItem.qt = p.produtoTela.valorMultiplo;
          } else {
            novoItem.qt = 1;
          }

          this.selecionarProduto(novoItem);
        });
      }
    }
    );
  }
}
